import { Controller } from "@hotwired/stimulus";

// 顧客向けお知らせの「お客様と同じ見た目」のプレビューを <dialog> 内の iframe で表示する。
// 一覧・顧客詳細の「詳細」ボタンから呼び出し、画面遷移せずにモーダル表示する。
//
// 使い方:
//   <div data-controller="notification-preview-modal">
//     <button data-action="notification-preview-modal#open"
//             data-notification-preview-modal-url-param="<preview_iframe のURL>">詳細</button>
//     ... (一覧/リスト) ...
//     <%= render 'admin/customer_notifications/preview_modal' %>
//   </div>
export class NotificationPreviewModalController extends Controller {
  static targets = ["dialog", "frame"];

  open(event) {
    const url = event.params.url;
    if (!url) return;

    this.frameTarget.src = url;
    this.dialogTarget.showModal();
  }

  // 閉じるボタン or backdrop（ダイアログ自体）クリックで閉じる
  handleClick(event) {
    if (event.target.closest("[data-close-dialog]") || event.target === this.dialogTarget) {
      this.close();
    }
  }

  close() {
    this.dialogTarget.close();
    // 非表示時に中身を残すと次回の高さ計算や描画に影響するためクリアする
    this.frameTarget.removeAttribute("src");
  }
}
